import axios from 'axios'
import requesturl from '../requesturl'
import auth from "../auth";
import cookiemanager from "../managers/cookiemanager";

export default {

    async getMacPools(macPools) {
        await axios.get(requesturl() + "/api/latest/pool", {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                macPools(res.data);

                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async getAvailableMacsForPoolAndUser(macPool, response) {
        await axios.get(requesturl() + "/api/latest/pool/" + macPool.poolId + '/AvailableMacs',
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                response(res.data);
                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }
            });
    },

    async deleteMacPool(macPool, response) {
        await axios.delete(requesturl() + "/api/latest/pool/" + macPool.poolId,
            {headers: {Authorization: window.$cookies.get("token")}})
            .then((res) => {
                let responseObj = {
                    error: false,
                    status: res.status
                };

                response(responseObj);

                cookiemanager.updateCookies(res.headers);
            })
            .catch(error => {
                let responseObj = {
                    error: true,
                    status: error.response != null ? error.response.status : 503
                };
                if (error.response && error.response.status === 401) {
                    auth.logout();
                    window.$router.push('login');
                }

                response(responseObj)
            });
    },

    async postMacPool(macPool, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'post',
            url: requesturl() + '/api/latest/pool',
            headers: headers,
            data: JSON.stringify(macPool)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            
            let responseObj = {
                error: false,
                status: res.status
            };

            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }

            response(responseObj);
        });
    },

    async putMacPool(macPool, response) {

        let headers = {
            'Authorization': window.$cookies.get("token"),
            'Content-Type': 'application/json'
        };

        await axios({
            method: 'put',
            url: requesturl() + '/api/latest/pool/' + macPool.poolId,
            headers: headers,
            data: JSON.stringify(macPool)
        }).then((res) => {
            cookiemanager.updateCookies(res.headers);
            let responseObj = {
                error: false,
                status: res.status
            };
            response(responseObj);
        }).catch(error => {
            let responseObj = {
                error: true,
                status: error.response != null ? error.response.status : 503
            };

            if (error.response && error.response.status === 401) {
                auth.logout();
                window.$router.push('login');
            }
            response(responseObj);
        });
    }
}



// WEBPACK FOOTER //
// ./src/interfaces/poolinterface.js